import Collection from '@/models/Collection'
import { Module } from '@/models/Module'

export class Modules extends Collection {

	public models!: Module[]

	public model() {
		return Module
	}

	public defaults() {
		return {
			// orderBy: 'name',
		}
	}

	public routes() {
		return {
			fetch: 'modules',
		}
	}

	get sidebar() {
		const items = this.models.filter((model) => model.type !== 'submodule')
		const reduced = items.reduce((res: any, obj: any) => {
			const key = obj.group
			const newObj = {group: key, name: obj.label, to: obj.route }
			if (res[key]) {
				res[key].push(newObj)
			} else {
				res[key] = [ newObj ]
			}
			return res
		}, {})
		return reduced
	}
}
